export const DEFAULT_DILATION_MATRIX_SIZE = 2;
export const DEFAULT_GAUSSIAN_BLUR_MAMMOGRAPHY_ITERATIONS = 2;
export const DEFAULT_GAUSSIAN_BLUR_KERNEL_SIZE = 5;
export const MAX_BACKGROUND_MAMMOGRAPHY_GRAY_TONE_RANGE = 20;
export const MAX_BACKGROUND_MAMMOGRAPHY_GRAY_TONE_TO_CONTRAST = 10;
export const BASE_CONTRAST_LEVEL = 10;
export const MAX_GRAY_TONE_VALUE = 255;
export const MIN_MAX_GRAY_TONE_VALUE = 250;
